@if (previewContext) {
<div class="screen">
    <div class="preview-options" [class.open]="firstOpen" (mouseleave)="firstOpen = false">
        @for (item of previewContext.items | keyvalue; track item.key) {
        <div class="option" [class.active]="current === item.key" (click)="onPreview(item.key, item.value)">{{item.key}}</div>
        }
    </div>
    <iframe #frame [srcdoc]="" frameborder="0" class="preview-frame"></iframe>
</div>
}
